import { ResponsiveScreenSizes } from "app/utils/const";
import React, { Component } from "react";
import Media from "react-media";
import FormSubmittedHeaderDesktop from "./components/FormSubmittedHeaderDesktop/FormSubmittedHeaderDesktop";
import FormSubmittedHeaderMobile from "./components/FormSubmittedHeaderMobile/FormSubmittedHeaderMobile";
//
type Props = {
  selectedTab: string;
  onClickBack: (...args: Array<any>) => any;
};
//
export const TabTypes = {
  DEPOSIT: "DEPOSIT",
  WITHDRAW: "WITHDRAW",
};

class FormSubmittedHeader extends Component<Props> {
  render(): React.ReactElement<
    React.ComponentProps<React$FragmentType>,
    React$FragmentType
  > {
    const { selectedTab, onClickBack } = this.props;
    return (
      <React.Fragment>
        <Media
          query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
          render={() => (
            <FormSubmittedHeaderMobile
              onClickBack={onClickBack}
              selectedTab={selectedTab}
            />
          )}
        />
        <Media
          query={`(min-width: ${ResponsiveScreenSizes.desktop})`}
          render={() => (
            <FormSubmittedHeaderDesktop
              onClickBack={onClickBack}
              selectedTab={selectedTab}
            />
          )}
        />
      </React.Fragment>
    );
  }
}

export default FormSubmittedHeader;
